// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/shared/PriceAndShopTable/priceAndShopTable.scss
// module id = 1434
// module chunks = 10